<template lang="pug">
  .ml-10(
    v-if="shouldShowPaymentRecord"
  )
    a.timesheet-panel-payment-record(
      :href="teamPaymentLink"
      target="_blank"
    )
      i.hi-billing_history.hi-16.mr-5
      span Payment record

      span.label.payment-label.timesheet-payment-status(:class="teamPaymentDetail.status_sym")
        | {{ teamPaymentDetail.status }}
</template>
<script>
  import { isNil } from 'lodash-es';
  import { TeamPaymentsResource } from '~/resources';
  export default {
    name: 'PaymentRecordLink',
    props: {
      teamPaymentDetail: {
        type: Object,
        default: null,
      },
      timesheetTeamPaymentId: {
        type: Number,
        default: null,
      },
    },
    computed: {
      shouldShowPaymentRecord() {
        if (isNil(this.teamPaymentDetail)) {
          return false;
        }

        return this.timesheetTeamPaymentId !== this.teamPaymentDetail.team_payment_id;
      },
      teamPaymentLink() {
        return TeamPaymentsResource.showLink({ id: this.teamPaymentDetail.team_payment_id });
      },
    },
  };
</script>
